<template>
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-note>
          <template v-if="typeMission === 'reservation'">
            Mes bons de location
          </template>

          <template v-else>Mes lettres de voiture</template>
        </ion-note>
      </ion-col>
    </ion-row>
  </ion-grid>

  <div v-if="rentalCoupons && rentalCoupons.length">
    <rental-coupon
      v-for="rentalCoupon in rentalCoupons"
      :type-mission="typeMission"
      :rental-coupon="rentalCoupon"
      v-bind:key="rentalCoupon.id"
    />
  </div>

  <ion-grid v-else>
    <ion-row>
      <ion-col class="text-align-center mt-15 mb-10">
        <ion-label>
          <template v-if="typeMission === 'reservation'">
            Aucun bon de location
          </template>
          <template v-else>Aucune lettre de voiture</template>
          pour l'instant
        </ion-label>
      </ion-col>
    </ion-row>
  </ion-grid>
</template>

<script>
import { IonNote, IonLabel } from '@ionic/vue';
import RentalCoupon from '@/components/driver/card/RentalCoupon';
import HasCouponSharing from '@/components/driver/rentalCoupon/mixins/HasCouponSharing';

export default {
  name: 'ListeRentalCoupon',
  components: {
    RentalCoupon,
    IonNote,
    IonLabel,
  },
  props: {
    rentalCoupons: {},
    typeMission: String,
  },
  mixins: [HasCouponSharing],
};
</script>
